import {getDashboardPeriods} from 'services/utils/misc'
import {Table, TableCell, TableHead, TableRow, styled} from '@mui/material'
import {useGetPlannerActivitiesQuery, useI18n} from 'store/Store'
import moment from 'moment'

const PaymentsList = ({isMobile}) => {
    const {i18n} = useI18n()
    const {today, monthAgo} = getDashboardPeriods()
    const {data: activities} = useGetPlannerActivitiesQuery({
        activitiesFrom: monthAgo,
        activitiesTo: today,
    })
    const {payments} = activities || {}

    if (!activities) {
        return null
    }

    return (
        <Container>
            <Table>
                <TableHead>
                    <TableRow>
                        {i18n
                            .t('settings.paymentList.tableTitles')
                            .map((tableTitle) => (
                                <TableCell
                                    align="right"
                                    sx={{fontWeight: 'bold'}}>
                                    {tableTitle}
                                </TableCell>
                            ))}
                    </TableRow>
                </TableHead>
                {payments.map((payment) => {
                    const {
                        PlannerPayment1: rawAmount,
                        PlannerTranzila_Invoice: invoice,
                        PlannerTranzila_MaskedPan: card,
                        RequestPaymentDay: rawDate,
                    } = payment
                    const amount = `₪${rawAmount}`
                    const date = moment(rawDate).format('DD.MM.YYYY')
                    return (
                        <TableRow>
                            {[date, card, amount, invoice].map((value) => (
                                <TableCell align="right">{value}</TableCell>
                            ))}
                        </TableRow>
                    )
                })}
            </Table>
        </Container>
    )
}

export default PaymentsList

const Container = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 24px;
    background: #cbddee33;
    width: 100%;
    height: 100%;
    padding: 24px;
`
